import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { fontStyle, fluidPadding } from '@/css/resources/mixins.css';
import {
	grid,
	resetFirstChildMarginTop,
	resetLastChildMarginBottom,
} from '@/css/resources/placeholders.css';
import { getColumnLeftStyle } from '@/css/shared/columns.css';

const getDynamicStyles = (styles) =>
	cssObj(fluidPadding(styles?.padding), {
		background: styles?.backgroundColor,

		'.supt-section__inner': {
			'.supt-section__content': getColumnLeftStyle(
				styles?.columns?.content
			),
			'.supt-section__headline': cssObj(
				getColumnLeftStyle(styles?.columns?.headline),
				{
					'.supt-section__uptitle': fontStyle({
						...styles?.uptitle?.typography,
						textAlign: styles?.uptitle?.textAlignment,
						color: styles?.uptitle?.color,
					}),
					'.supt-section__title': fontStyle({
						...styles?.title?.typography,
						textAlign: styles?.title?.textAlignment,
						color: styles?.title?.color,
					}),
					'.supt-section__introduction': fontStyle({
						...styles?.introduction?.typography,
						textAlign: styles?.introduction?.textAlignment,
						color: styles?.introduction?.color,
					}),
				}
			),
		},

		'.supt-introduction': fontStyle({
			...styles?.introduction?.typography,
			textAlign: styles?.introduction?.textAlignment,
			color: styles?.introduction?.color,
		}),
	});

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		'.supt-section__inner': cssObj(grid, {
			'.supt-section__headline': resetFirstChildMarginTop,
			'.supt-section__content': resetLastChildMarginBottom,
		}),
	});

export { getStyles };
